module.exports = __webpack_public_path__ + "assets/sushi-08ecb2.svg";